export const nameData = [
  {
    name: "CE01",
  },
  {
    name: "CE04",
  },
  {
    name: "CE09",
  },
  {
    name: "CE10",
  },
  {
    name: "EE04",
  },
  {
    name: "EE05",
  },
  {
    name: "EE11",
  },
  {
    name: "ME06",
  },
];

export const descriptionData = [
  {
    description: "Roads & Pavements Drainage & Retaining Structure",
  },
  {
    description:
      "Dams / Water Retaining Structures Irrigation & Flood Control System",
  },
  {
    description: "Sewerage Works Water Supply",
  },
  {
    description:
      "General Civil Engineering Works Concrete Repairs Stabilization Landscaping & Horticulture Reclamation Works General Buildings and Maintenance Water Proofing",
  },
  {
    description: "Low Voltage Installation",
  },
  {
    description: "High Voltage Installation",
  },
  {
    description: "Any Other Works",
  },
  {
    description:
      "Specialized Fabrication and Treatment Medical Equipment Kitchen and Laundry Equipment Heat Recovery System Pollution Control System Miscellaneous Mechanical Equipment Chiller for Power Generation Specialized Plant.",
  },
];
